<div *ngIf="isLoading"
    class="d-flex flex-column justify-content-center align-items-center"
    [ngClass]="isFullScreen ? 'spinner-container-full-screen' : 'spinner-container-component'">

    <fa-icon [icon]="['fas', 'spinner']" [spin]="true" class="spinner-icon me-2"></fa-icon>

</div>
